






































































































































































































































































































































































































































































interface httpBody {
	accountBookId: number;
	subjectId: null | number;
	startPeriod: string;
	endPeriod: string;
	relation: null | Assist.Relation;
	assistingAccountId: null;
	isHideTotal: number;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ChooseSubjectVue from "../components/ChooseSubject.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import NumCurrencySubsidiaryVue from "../components/SubsidiaryLedger/NumCurrencySubsidiary.vue";
import SubjectAssistVue from "../components/SubsidiaryLedger/SubjectAssist.vue";
import version from "@/version";
import { ElTree } from "element-ui/types/tree";
@Component({
	...mapGetters(["accountBook"]),
	components: {
		"choose-subject": ChooseSubjectVue,
		"month-selector": MonthSelectorVue,
		"num-currency-subsidiary": NumCurrencySubsidiaryVue,
		"subject-assist": SubjectAssistVue,
	},
})
export default class SubsidiaryLedger extends Vue {
	@Prop({ type: Boolean })
	isDialog?: boolean;

	@Prop({ type: Object })
	subject?: Subject.Subject;

	@Prop({ type: Array })
	appointDate?: Date[];

	@Prop({ type: [Object, Array] })
	relation?: Assist.Relation;

	tableData: Subsidiary[] = [];
	currSymbol: null | string = null;
	measuringUnit: null | string = null;
	accountTypeName: null | string = null;
	startSubjectNo:any = "";
	endSubjectNo:any = "";
	minLevel:any = 1;
	maxLevel:any = 5;
	isHideTotal:any = 0;

	// 改变科目数据
	subjectVal: Subject.Subject | null = null; //选中的科目
	changeSubject(val: Subject.Subject) {
		this.subjectVal = val;
		this.fetchData();
		this.update(val);
	}

	subjectList: Subject.Subject[] = [];
	filterVisible = false;
	visible = false
	startSubject: Subject.Subject | null = null;
	endSubject: Subject.Subject | null = null;
	getList(arr: Subject.Subject[]) {
		arr.forEach((v, i) => {
			v.index = i;
		});
		this.subjectList = arr;
	}
	resetFilter() {
		this.startSubject = null;
		this.endSubject = null;
	}
	async confirmFilter() {
		// this.fetchData();
		const url = `${Vue.axios.defaults.baseURL}export/pdf/subsidiaryledger/all?${this.startSubject !== null ? "startSubjectNo=" + this.startSubject.no : ""}${this.endSubject !== null ? "&endSubjectNo=" + this.endSubject.no : ""}&accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}`;
		this.$utils.sendToElectron("download-pdf", url);
		this.filterVisible = false;
	}
	async reset() {
		this.isHideTotal = 0
		this.startSubjectNo = ""
		this.endSubjectNo = ""
		this.minLevel = 1
		this.maxLevel = 5
		await this.fetchTreeSubject()
		this.fetchData()
		this.visible = false
	}
	async confirm() {
		await this.fetchTreeSubject()
		this.fetchData();
		this.visible = false
		// @ts-ignore
		// (<ElTree>this.$refs.subjectTree).filter("")
	}
	mounted() { }

	// 日期改变
	period: string[] = []; // 日期
	changeDate(date: string[]) {
		this.period = date;
		this.fetchData();
		this.fetchTreeSubject(false);
	}

	// 打开凭证号 的模态框\
	isVoucher: boolean = false;
	openDialogVoucher(data: Subsidiary) {
		if (data.voucherId != -1) {
			this.isVoucher = true;
			this.$nextTick(function () {
				let comVoucher: any = this.$refs.voucher;
				comVoucher.isDialog = true;
				comVoucher.shouldGetInit = false;
				comVoucher.getSubjectList(
					data.date.replace(/-/, "").substring(0, 6),
					() => {
						Vue.axios
							.post(`voucher/` + data.voucherId + `/find`, {
								id: 123,
							})
							.then((res) => {
								comVoucher.packVoucher(res.data);
								comVoucher.isEdit = true;
								comVoucher.showSaveAndAdd = false;
								comVoucher.showAdd = false;
							});
					}
				);
			});
		}
	}

	// 获取表格数据
	async fetchData() {
		if (this.period.length > 0) {
			let obj: httpBody = {
				accountBookId: this.$store.state.accountBook.id,
				subjectId: null,
				startPeriod: this.period[0],
				endPeriod: this.period[1],
				relation: null,
				assistingAccountId: null,
				isHideTotal: this.isHideTotal?1:0
			};

			if (this.subjectVal) {
				obj.relation = null;
				obj.subjectId = <number>this.subjectVal.id;
			} else {
				if (this.subject && this.relation) {
					obj.subjectId = <number>this.subject.id;
					obj.relation = this.relation;
				} else if (this.subject) {
					obj.subjectId = <number>this.subject.id;
				}
			}
			let res = await Vue.axios.post(`details/find`, obj)
			if (res) {
				this.isEmptyTree = this.treeData.length === 0 && !this.subject;
				this.tableData = res.data.subsidiarys;
			}
		}
	}

	// 选中时的背景
	addColor(event: any) {
		let dataTbody: any = document.querySelectorAll(".data-tbody tr");
		for (let i = 0; i < dataTbody.length; i++) {
			if (
				dataTbody[i].classList.contains("lighter-main-color-background")
			)
				dataTbody[i].classList.remove("lighter-main-color-background");
		}
		event.currentTarget.classList.add("lighter-main-color-background");
	}

	// 其他种类明细账
	handleCommand(command: string) {
		if (command === "true") {
			this.showAssist = true;
		} else {
			this.showDetailNum = true;
		}
	}
	// 下拉的判断
	unequal(param: string | null) {
		if (param == null || param == "") {
			return null;
		} else {
			return param;
		}
	}
	update(val: Subject.Subject) {
		this.currSymbol = this.unequal(val.currSymbol);
		let isStorage =
			val.dimAccountType != null && val.dimAccountType.includes("存货");
		this.measuringUnit =
			this.unequal(val.measuringUnit) || isStorage ? "" : null;
		if (isStorage) {
			if (this.subjectVal) this.subjectVal.measuringUnit = "";
		}
		this.accountTypeName = this.unequal(val.dimAccountType);
	}
	// 是否显示下拉Icon
	get dropDownIcon() {
		if (
			this.currSymbol == null &&
			this.measuringUnit == null &&
			this.accountTypeName == null
		) {
			return false;
		} else {
			return true;
		}
	}

	// 科目辅助明细账
	showAssist: boolean = false;
	closeAssist() {
		this.showAssist = false;
	}
	assistSuccess() {
		this.showAssist = false;
	}
	// 非科目辅助明细账
	showDetailNum: boolean = false;
	closeDetailNum() {
		this.showDetailNum = false;
	}
	detailNumSuccess() {
		this.showDetailNum = false;
	}

	// 获取时间区间
	get yearMonth() {
		if (this.period[0] === this.period[1]) {
			return (
				this.period[0].substring(0, 4) +
				"年" +
				this.period[0].substring(4) +
				"月"
			);
		} else {
			return (
				this.period[0].substring(0, 4) +
				"年" +
				this.period[0].substring(4) +
				"月至" +
				this.period[1].substring(0, 4) +
				"年" +
				this.period[1].substring(4) +
				"月"
			);
		}
	}
	// 下载
	downLoad() {
		let url = `${Vue.axios.defaults.baseURL}export/subsidiaryledger/all?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}&startSubjectNo=${this.startSubjectNo}&endSubjectNo=${this.endSubjectNo}&minLevel=${this.minLevel}&maxLevel=${this.maxLevel}&isHideTotal=${this.isHideTotal?1:0}`;
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", url);
	}
	// 本页下载
	pageDownLoad() {
		if (this.subjectVal) {
			let url = `${Vue.axios.defaults.baseURL}export/subsidiaryledger?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}&isHideTotal=${this.isHideTotal?1:0}`;
			this.$store.dispatch("toggleDownload", true);
			this.$utils.sendToElectron("download", url);
		}
	}

	// subject tree
	treeVisible = true;
	treeQuery = "";
	treeData = [];
	defaultProps = {
		children: "children",
		label(data: Subject.Subject) {
			return data.no + " " + data.text;
		},
	};

	async fetchTreeSubject(shouldChange = true) {
		const res = await Vue.axios.get(
			`subjects/find/has/balance?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&startSubjectNo=${this.startSubjectNo === null?"":this.startSubjectNo}&endSubjectNo=${this.endSubjectNo === null?"":this.endSubjectNo}&minLevel=${this.minLevel}&maxLevel=${this.maxLevel}`
		);
		this.treeData = res.data.subjects;

		if (shouldChange) this.subjectVal = res.data.subjects[0];
	}

	filterNode(value: string, data: any) {
		if (!value) return true;
		return ((data.no + data.text).indexOf(value) !== -1);
	}
	isEmptyTree = false;
	@Watch("treeQuery")
	queryChange(v: string) {
		// @ts-ignore
		(<ElTree>this.$refs.subjectTree).filter(v);
		this.$nextTick(() => {
			// @ts-ignore
			this.isEmptyTree = (<ElTree>this.$refs.subjectTree).isEmpty;
		});
	}

	changeTreeSubject(data: Subject.Subject) {
		this.changeSubject(data);
	}
}
